import { render, staticRenderFns } from "./volume.vue?vue&type=template&id=256fedce&scoped=true&"
import script from "./volume.vue?vue&type=script&lang=js&"
export * from "./volume.vue?vue&type=script&lang=js&"
import style0 from "./volume.vue?vue&type=style&index=0&id=256fedce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fedce",
  null
  
)

export default component.exports